/*
  Keep action/resource static — see dashboard.js for why ability.can() at
  import time breaks the sidebar after login until refresh.
*/
export default [
  {
    header: 'Sattva Infra Menu',
  },
  {
    title: 'Sattva Infra',
    icon: 'HomeIcon',
    resource: 'infra',
    action: 'read',
    children: [
      {
        title: 'Infra Tracker',
        route: 'infra-inquiry',
        resource: 'infra',
        action: 'read',
      },
    ],
  },
]
